module.exports = __webpack_public_path__ + "static/fairmont-kea-lani.80b5a2fa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/logos/fairmont-kea-lani.png
// module id = 73
// module chunks = 168707334958949